import { render, staticRenderFns } from "./LoopingRhombusesSpinner.vue?vue&type=template&id=0458ce94&scoped=true&"
import script from "./LoopingRhombusesSpinner.vue?vue&type=script&lang=js&"
export * from "./LoopingRhombusesSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoopingRhombusesSpinner.vue?vue&type=style&index=0&id=0458ce94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0458ce94",
  null
  
)

export default component.exports